import Phaser from 'phaser';

export default class RoundIndicator extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,totalRounds,past,future,current) {
    super(scene);

    this.rounds = [];
    this.numberOfRounds = totalRounds;
    this.pastStyle = past;
    this.futureStyle = future;
    this.name = 'indicator';
    this.currentStyle = current === null ? this.pastStyle : current;

    // add dots
    this.rounds = [];
    const roundSpacing = 10;
    const circleWidth = 15;
    const totalWidth = (this.numberOfRounds * (circleWidth + roundSpacing)) - roundSpacing;
    const startX = (this.scene.scale.width / 2) - (totalWidth / 2);

    for (let i = 0; i < this.numberOfRounds; i++) {
      const roundDisplay = this.scene.add.circle(startX + (i * (circleWidth + roundSpacing)),15,10,0xffffff);
      this.add(roundDisplay);
      this.rounds.push(roundDisplay);
    }
  }

  showRound (roundNum) {
    for (let i = 0; i < this.rounds.length; i++) {
      const rDisplay = this.rounds[i];
      let style;
      if (i === roundNum - 1) {
        style = this.currentStyle;
      }
      else if (i < roundNum - 1) {
        style = this.pastStyle;
      }
      else {
        style = this.futureStyle;
      }

      rDisplay.setStrokeStyle(style._thickness, style._lineColor);
      rDisplay.setFillStyle(style._fillColor);
    }
  }
}